import { render } from "./PlanetSection.vue?vue&type=template&id=6d14db10&scoped=true"
import script from "./PlanetSection.vue?vue&type=script&lang=js"
export * from "./PlanetSection.vue?vue&type=script&lang=js"

import "./PlanetSection.vue?vue&type=style&index=0&id=6d14db10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d14db10"]])

export default __exports__